// Imports from the packages
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Button } from "react-bootstrap";
import { Image } from "lib";

// Assests import
import adgmLogo from "assets/images/kotak_logo_adgm.svg";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import Signdesk_logo_white from "assets/images/signdesk_logo_white.svg";
import User from "assets/images/user.svg";
import client_logo_2 from "assets/images/signdesk_logo_white.svg";

// File import - local directory
import Activity from "components/Activity";
import "./index.scss";

// Specific function import - local directory
import {
    setDashboardState,
    setActiveSelectedTab,
    setSidebarLoading,
    setNumberOfRecords,
    setRowPerPage,
    setPrepopulateDefaultFilter,
    setSelectedTableSortOptions
} from "redux/dashboardReducer";
import {
    ResetDashBoardDetailData,
    clearuserSubworkFlowInfo,
    ResetCurrentSubworkFlowId,
    ResetDashboardDetailConfiguration
} from "redux/dashBoardDetailReducer";
import { setLogoUrl } from "redux/urlEncryption";
import { LOGIN_ROUTE } from "constants/routes";

// import { setAppColor } from "helper";

const SideBar = (props) => {
    // Destructure props
    const {
        templateName,
        sidebarToggle,
        sidebarStructure,
        clearAllFilterArray
    } = props;

    // Redux hooks
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Local state variables
    const [isMobile, setIsMobile] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [show, setShow] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [showReports, setShowReports] = useState(false);
    const [showUserModule, setShowUserModule] = useState(false);
    const [showCLMRepository, setShowCLMRepository] = useState(false);

    // Handle LOGIN_ROUTE
    let updatedRoute = LOGIN_ROUTE.replace("/accounts/login", "");

    /*
        Use this when we have all internal products as microservices
    */
    // updatedRoute = window.location.href.includes('unified') 
    //    ? window.location.href.split("unified")[0] 
    //    : updatedRoute

    // Sidebar List items configurations
    const reportListItem = {
        list_name: "Reports",
        routing_link: `${updatedRoute}/report`,
        show: "true",
        menu_items: [],
        id: "reports",
        target: "_self"
    };

    const userListItem = {
        list_name: "Users",
        menu_items: [],
        icon: "account",
        routing_link: `${updatedRoute}/accounts/users`,
        show: "true",
        id: "users",
        target: "_self"
    };

    // CLM is monolithic in the demo instance so this might not work in demo
    const clmRepositoryListItem = {
        list_name: "Repository",
        menu_items: [],
        icon: "account",
        routing_link: `${updatedRoute}/clm/#/repository`,
        show: "true",
        id: "Repository",
        target: "_blank"
    };

    // Local state variables dependent on Redux values
    const [dashBoardConfigData, setDashBoardConfigData] = useState(
        useSelector((state) => state.dashboardDetailReducer?.configurationInfo)
    );

    // Redux state variables
    const { dashboardDetailConfiguration } = useSelector((state) => state.dashboardDetailReducer);
    const { workflow_modules } = useSelector((state) => state.dashboardReducer);
    const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
    const logoName = useSelector((state) => state.loggedInUserInfo?.userAuthInfo?.organisationInfo)?.logo;
    const iconName = useSelector((state) => state.loggedInUserInfo?.userAuthInfo?.organisationInfo)?.icon;
    const logoMobile = useSelector((state) => state.loggedInUserInfo?.userAuthInfo?.organisationInfo)?.logo;

    const activeSelectedTab = useSelector((state) => state.dashboardReducer.activeSelectedTab);
    const modulePermissions = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)?.modules;

    // Permission-based sidebar logic
    let permissionBasedSideBar = [];
    const [toggle, setToggle] = useState(true);

    // if(modulePermissions?.length == undefined){
    //     setSidebarLoading(true);

    // }
    // adding this use effect to tract the redux value change and update the local variable state
    useEffect(() => {
        // set the local state variable to new redux value
        setDashBoardConfigData(dashboardDetailConfiguration)
    }, [dashboardDetailConfiguration])

    useEffect(() => {
        // console.log("calling here 2", modulePermissions);
        // set the local state variable to new redux value
        if (modulePermissions?.length > 0 && showReports === false) {
            modulePermissions.map((item) => {
                if (item?.module_id?.toString() === "66a8be5618ea4f5a5e7c3d9b") {
                    setShowReports(true)
                }
                return true;

            })
        }
        if (modulePermissions?.length > 0 && showUserModule === false) {
            modulePermissions.map((item) => {
                if (item?.module_id?.toString() === "59d4ac0cf4751a371a1c2066") {
                    setShowUserModule(true)
                }
                return true;

            })
        }
        if (modulePermissions?.length > 0 && showCLMRepository === false) {
            modulePermissions.map((item) => {
                if (item?.module_id?.toString() === "66a9ec4618ea4f5a5ed09cd8") {
                    setShowCLMRepository(true)
                }
                return true;
            })
        }    
    }, [modulePermissions])

    const checkWindowWidth = () => {
        const width = window.innerWidth;
        if (width <= 992 && !isMobile) {
            setIsMobile(true);
        } else if (width > 992 && isMobile) {
            setIsMobile(false);
        }
    };
    window.addEventListener("resize", () => checkWindowWidth());

    // use the below useEffect to render image from org settings
    useEffect(() => {
        // console.log("jfdsfjd", loggedInUserInfo?.organisationInfo?.logo)
        checkWindowWidth();
        let res = loggedInUserInfo?.organisationInfo
        if (loggedInUserInfo?.organisationInfo?.logo)
            dispatch(setLogoUrl("https://signdesk.in/company/" + res?.logo));
        const list = document.getElementById('favicon_customized');
        list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
        const titleName = document.getElementById('title-id');
        titleName.innerText = res?.setting?.parent_client_name || "loading...";
        // eslint-disable-next-line
    }, [])

    // we might need this later in future 
    // eslint-disable-next-line   
    const validateRoleBasedOnModuleId = (item) => {
        let isvalidated = false;
        let modules = loggedInUserInfo?.modules;
        if (eval(item?.show)) {
            if (item?.routing_link !== undefined) {
                isvalidated = true;
            } else if (item?.routing_link === undefined && item?.module_id) {
                modules?.forEach((element) => {
                    if (element?.module_id === item?.module_id) {
                        isvalidated = true;
                    }
                });
            }
        }
        return isvalidated;
    };

    if (!sidebarStructure?.list_items.length) {
        // console.log("loading",setSidebarLoading)
        setSidebarLoading(true);
    } else {
        // console.log("not loading",setSidebarLoading)
        setSidebarLoading(false);
    }
    if (showReports || showUserModule || showCLMRepository) {

        showReports && permissionBasedSideBar.push(reportListItem);
        showUserModule && permissionBasedSideBar.push(userListItem);
        showCLMRepository && permissionBasedSideBar.push(clmRepositoryListItem)

        setSidebarLoading(false);
        // console.log("🚀 ~ SideBar ~ reportListItem:", reportListItem)
    }
    // Offcanvas
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseSidebar = () => setShowSidebar(false);
    const handleShowSidebar = () => setShowSidebar(true);

    const handleLinkClick = (item, index) => {
        if (item?.detail_view_module_id) {
            const module_id = item?.module_id || workflow_modules?.[item.module_name];
            const currentModule = {
                id: module_id,
                name: item.module_name,
                detail_view_module_id: item?.detail_view_module_id,
            };
            dispatch(
                setDashboardState({ key: "current_module", value: currentModule })
            );

            clearAllFilterArray?.()
            dispatch(setPrepopulateDefaultFilter({}));
            dispatch(setSelectedTableSortOptions({}));
            dispatch(setActiveSelectedTab(index));
            dispatch(setNumberOfRecords(5))
            dispatch(setRowPerPage(5))
            if (!window.location.pathname?.includes("dashboard-listing")) {
                navigate("/dashboard-listing");
            }
            dispatch(ResetDashBoardDetailData());
            dispatch(clearuserSubworkFlowInfo());
            dispatch(ResetCurrentSubworkFlowId());
            dispatch(ResetDashboardDetailConfiguration());

        }
        handleCloseSidebar();
    };

    if (dashBoardConfigData && Object.keys(dashBoardConfigData)?.length) {
        let formStructure = [];
        dashBoardConfigData?.wf_journey?.map((item, index) => {
            formStructure = { ...item?.form_structure };
        });

    }

    let currentPath = useLocation()

    const displaySidebar = () => {
        setToggle(!toggle)
        sidebarToggle(toggle)
        setDropdown(false)
    }

    const toggleDropdown = () => {
        if (toggle) {
            setToggle(!toggle)
            sidebarToggle(toggle)
        }
        setDropdown(!dropdown)
    }

    const handleLogoClick = () => {
        navigate("/dashboard-listing")
    };

    return (
        <>
            {isMobile ? (
                <>
                    <Navbar
                        key={false}
                        expand={false}
                        sticky="top"
                        className="mb-3 nav-bar-button bg-white shadow-sm position-sticky top-0 z-index-10"
                    >
                        <Container fluid>
                            <Navbar.Brand
                                href="#home"
                                className="d-flex align-items-center justify-content-between w-100 me-0"
                            >
                                <div>
                                    <Navbar.Toggle
                                        onClick={handleShowSidebar}
                                        aria-controls={`offcanvasNavbar-expand-${false}`}
                                        className="nav_button mb-0"
                                    />
                                    <Image
                                        className="d-none d-lg-block w-50 h-25"
                                        imageSrc={
                                            templateName?.includes('adgm')
                                                ? adgmLogo
                                                : templateName?.includes('difc')
                                                    ? client_logo_2
                                                    : Signdesk_logo
                                        }
                                        width="100px"
                                        height="40px"
                                        alt=""
                                        onClick={() => {
                                            handleLogoClick();
                                        }}
                                    />
                                    <Image
                                        className="d-lg-none h-35px"
                                        imageSrc={
                                            logoName
                                                ? `https://signdesk.in/company/${logoMobile}`
                                                : Signdesk_logo
                                        }
                                        onClick={() => {
                                            handleLogoClick();
                                        }}
                                    />
                                </div>

                                {/* mobile activity button */}
                                {currentPath.pathname.includes(
                                    'dashboard-detail'
                                )
                                    ? (
                                        <Button
                                            variant="white"
                                            className="border-0"
                                            onClick={handleShow}
                                        >
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22.999"
                                                    height="21.646"
                                                    viewBox="0 0 22.999 21.646"
                                                >
                                                    <path
                                                        id="Path_56667"
                                                        data-name="Path 56667"
                                                        d="M162.314,112.635l2.706-3.382h-1.712a8.8,8.8,0,1,1,.92,6.87l-1.765.983a10.818,10.818,0,1,0-1.236-7.853h-1.617m11.162-3.382v6.247l.391.3,3.044,2.368.8.624,1.247-1.6-.8-.624-2.653-2.061v-5.253Z"
                                                        transform="translate(-159.609 -100.797)"
                                                        fill="#515151"
                                                    />
                                                </svg>
                                            </span>
                                        </Button>
                                    ) : (
                                        <></>
                                    )}
                            </Navbar.Brand>

                            <Offcanvas
                                show={showSidebar}
                                onHide={handleCloseSidebar}
                                id={`offcanvasNavbar-expand-${false}`}
                                className="sidebarContent w-50"
                                aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
                                placement="start"
                            >
                                <Offcanvas.Header
                                    closeButton
                                    closeVariant="white"
                                    bsPrefix="offcanvas-header btn-close-offcanvas-no-shadow"
                                >
                                    <Offcanvas.Title
                                        id={`offcanvasNavbarLabel-expand-${false}`}
                                    >
                                        <Image
                                            imageSrc={
                                                logoName
                                                    ? `https://signdesk.in/company/${logoName}`
                                                    : Signdesk_logo_white
                                            }
                                            width="80px"
                                            height="24px"
                                            className="d-inline-block align-top dashboard-nav-logo-offcanvas w-100px"
                                            alt=""
                                            onClick={() => {
                                                handleLogoClick();
                                            }}
                                        />
                                    </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <Nav className="d-flex h-100 justify-content-between pe-lg-3">
                                        <div className="d-flex flex-column">
                                            {sidebarStructure?.list_items
                                                .length &&
                                                sidebarStructure?.list_items.map(
                                                    (item, index) =>
                                                        !item?.show ||
                                                            eval(item?.show) ? (
                                                            item?.menu_items
                                                                ?.length ? (
                                                                <div
                                                                    key={index}
                                                                >
                                                                    <Nav.Link
                                                                        key={
                                                                            item?.list_name
                                                                        }
                                                                        target={
                                                                            item?.target
                                                                        }
                                                                        className="sidebar_nav_link d-flex align-items-center"
                                                                        onClick={() =>
                                                                            setDropdown(
                                                                                !dropdown
                                                                            )
                                                                        }
                                                                    >
                                                                        <Image
                                                                            imageSrc={
                                                                                User
                                                                            }
                                                                            className="p-2"
                                                                        />
                                                                        <p className="nav_link_text mx-2 my-1">
                                                                            {
                                                                                item?.list_name
                                                                            }
                                                                        </p>
                                                                        <div
                                                                            className={`${!dropdown
                                                                                ? 'd-block'
                                                                                : 'd-none'
                                                                                } ms-2`}
                                                                        >
                                                                            <span className="d-flex">
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="14"
                                                                                    height="14"
                                                                                    viewBox="0 0 7.605 4.302"
                                                                                >
                                                                                    <path
                                                                                        id="Path_8068"
                                                                                        data-name="Path 8068"
                                                                                        d="M0,0,3.1,3.1,0,6.191"
                                                                                        transform="translate(6.898 0.707) rotate(90)"
                                                                                        fill="none"
                                                                                        stroke="#fff"
                                                                                        stroke-linecap="round"
                                                                                        stroke-linejoin="round"
                                                                                        stroke-width="1"
                                                                                        opacity="0.995"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                        </div>
                                                                        <div
                                                                            className={`${dropdown
                                                                                ? 'd-block'
                                                                                : 'd-none'
                                                                                } ms-2`}
                                                                        >
                                                                            <span className="d-flex">
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="14"
                                                                                    height="14"
                                                                                    viewBox="0 0 7.606 4.303"
                                                                                >
                                                                                    <path
                                                                                        id="Path_8068"
                                                                                        data-name="Path 8068"
                                                                                        d="M0,6.191,3.1,3.1,0,0"
                                                                                        transform="translate(0.707 3.596) rotate(-90)"
                                                                                        fill="none"
                                                                                        stroke="#fff"
                                                                                        stroke-linecap="round"
                                                                                        stroke-linejoin="round"
                                                                                        stroke-width="1"
                                                                                        opacity="0.995"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                        </div>
                                                                    </Nav.Link>
                                                                    <>
                                                                        {dropdown && (
                                                                            <div className="submenu">
                                                                                {item?.menu_items?.map(
                                                                                    (
                                                                                        data,
                                                                                        _index
                                                                                    ) => {
                                                                                        return (
                                                                                            <div
                                                                                                key={
                                                                                                    _index
                                                                                                }
                                                                                                style={{
                                                                                                    borderLeft:
                                                                                                        _index ===
                                                                                                            activeSelectedTab
                                                                                                            ? '5px solid red'
                                                                                                            : '5px solid $primary_color',
                                                                                                    cursor: 'pointer'
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    handleLinkClick(
                                                                                                        data,
                                                                                                        _index
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <div className="submenu_list">
                                                                                                    <p className="list_items">
                                                                                                        {data?.routing_link ? (
                                                                                                            <Link
                                                                                                                to={
                                                                                                                    data?.routing_link
                                                                                                                }
                                                                                                            />
                                                                                                        ) : null}
                                                                                                        {
                                                                                                            data.name
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <Nav.Link
                                                                        key={
                                                                            item?.list_name
                                                                        }
                                                                        href={
                                                                            item?.routing_link
                                                                        }
                                                                        onClick={() =>
                                                                            handleLinkClick(
                                                                                item,
                                                                                index
                                                                            )
                                                                        }
                                                                        className="sidebar_nav_link"
                                                                    >
                                                                        <div className="sidebar_nav_link d-flex align-items-center">
                                                                            <Image
                                                                                imageSrc={
                                                                                    User
                                                                                }
                                                                                className="nav_link_icon p-2 m-0"
                                                                            />
                                                                            <p className="nav_link_text my-2 mx-2">
                                                                                {
                                                                                    item?.list_name
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </Nav.Link>

                                                                    <Nav.Link
                                                                        key={
                                                                            item?.list_name
                                                                        }
                                                                        className="sidebar_nav_link"
                                                                    >

                                                                    </Nav.Link>
                                                                </>
                                                            )
                                                        ) : null
                                                )}
                                        </div>

                                        {/* <Nav.Link
                                            href="#action4"
                                            className="sidebar_nav_link d-inline-flex mb-2 align-items-center"
                                            onClick={() => {
                                                logout();
                                            }}
                                        >
                                            <img
                                                src={Logout_icon}
                                                width="30"
                                                height="30"
                                                className="nav_link_icon me-2"
                                                alt=""
                                            />
                                            <p
                                                className={
                                                    isMobile
                                                        ? 'nav_link_text my-0'
                                                        : 'nav_link_text my-0'
                                                }
                                            >
                                                Log Out
                                            </p>
                                        </Nav.Link> */}
                                    </Nav>
                                </Offcanvas.Body>
                            </Offcanvas>
                        </Container>
                    </Navbar>

                    <Offcanvas show={show} onHide={handleClose} placement="end">
                        <button
                            className="btn btn-close position-absolute me-2 mt-3 top-0 end-0 z-index-5"
                            onClick={handleClose}
                        ></button>
                        <Activity />
                    </Offcanvas>
                </>
            ) : (
                <div className="position-relative vh-100">
                    <div className="pt-4 ps-3 pe-2 text-center">
                        {toggle ? (

                            <Image
                                imageSrc={`https://signdesk.in/company/${iconName}`}
                                className="h-35px"
                                onClick={() => {
                                    handleLogoClick();
                                }}
                            />
                        ) : (
                            <Image
                                imageSrc={
                                    logoName
                                        ? `https://signdesk.in/company/${logoName}`
                                        : Signdesk_logo_white

                                }
                                className=".client-logo img-fluid"
                                onClick={() => {
                                    handleLogoClick();
                                }}
                            />
                        )}
                    </div>

                    <Nav
                        as="ul"
                        className="d-block pt-2 overflow-hidden"
                        defaultActiveKey="javascript:;"
                    >
                        {sidebarStructure?.list_items.length &&
                            sidebarStructure?.list_items.map((item, index) =>
                                <>
                                    {item?.menu_items?.length ? (
                                        <>
                                            <Nav.Item
                                                eventKey="link-1"
                                                as="li"
                                                className="mt-2 ps-4 position-relative"
                                                key={item?.list_name}
                                                onClick={() =>
                                                    toggleDropdown()
                                                }
                                            >
                                                <Nav.Link
                                                    href="javascript:;"
                                                    className="d-flex align-items-center justify-content-between position-relative h-40px p-0 nav-sidebar"
                                                    target={item?.target}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="22"
                                                            viewBox="0 0 24.055 21.649"
                                                            fill="#343a40"
                                                        >
                                                            <path
                                                                id="conversion_path_FILL0_wght400_GRAD0_opsz24"
                                                                d="M100.446-818.351a3.5,3.5,0,0,1-2.1-.677,3.5,3.5,0,0,1-1.293-1.729H90.825a4.632,4.632,0,0,1-3.4-1.413,4.632,4.632,0,0,1-1.413-3.4,4.632,4.632,0,0,1,1.413-3.4,4.633,4.633,0,0,1,3.4-1.413H93.23a2.316,2.316,0,0,0,1.7-.707,2.316,2.316,0,0,0,.707-1.7,2.316,2.316,0,0,0-.707-1.7,2.315,2.315,0,0,0-1.7-.707H87.006A3.715,3.715,0,0,1,85.7-833.46a3.43,3.43,0,0,1-2.09.676,3.479,3.479,0,0,1-2.556-1.052A3.48,3.48,0,0,1,80-836.392a3.48,3.48,0,0,1,1.052-2.556A3.48,3.48,0,0,1,83.608-840a3.429,3.429,0,0,1,2.09.676,3.716,3.716,0,0,1,1.308,1.729H93.23a4.632,4.632,0,0,1,3.4,1.413,4.633,4.633,0,0,1,1.413,3.4,4.633,4.633,0,0,1-1.413,3.4,4.633,4.633,0,0,1-3.4,1.413H90.825a2.317,2.317,0,0,0-1.7.706,2.317,2.317,0,0,0-.707,1.7,2.316,2.316,0,0,0,.707,1.7,2.316,2.316,0,0,0,1.7.707h6.224a3.717,3.717,0,0,1,1.308-1.729,3.43,3.43,0,0,1,2.09-.676A3.479,3.479,0,0,1,103-824.515a3.479,3.479,0,0,1,1.052,2.556A3.479,3.479,0,0,1,103-819.4,3.48,3.48,0,0,1,100.446-818.351ZM83.608-835.189a1.164,1.164,0,0,0,.857-.346,1.163,1.163,0,0,0,.346-.857,1.164,1.164,0,0,0-.346-.857,1.164,1.164,0,0,0-.857-.346,1.164,1.164,0,0,0-.857.346,1.164,1.164,0,0,0-.346.857,1.163,1.163,0,0,0,.346.857A1.164,1.164,0,0,0,83.608-835.189Z"
                                                                transform="translate(-80 840)"
                                                            />
                                                        </svg>
                                                        <p
                                                            className={`my-1 me-1 mt-2 fs-15px text-dark ms-3 delay-200 ${toggle
                                                                ? 'opacity-0'
                                                                : 'opacity-100'
                                                                }`}
                                                        >
                                                            {
                                                                item?.list_name
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`pe-3 delay-200 ${toggle
                                                            ? 'opacity-0'
                                                            : 'opacity-100'
                                                            }`}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="12"
                                                            height="12"
                                                            viewBox="0 0 7.605 4.302"
                                                            className={`${dropdown
                                                                ? 'rotate-180deg'
                                                                : ''
                                                                }`}
                                                        >
                                                            <path
                                                                id="Path_8068"
                                                                data-name="Path 8068"
                                                                d="M0,0,3.1,3.1,0,6.191"
                                                                transform="translate(6.898 0.707) rotate(90)"
                                                                fill="none"
                                                                stroke="#343a40"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                stroke-width="1"
                                                                opacity="0.995"
                                                            />
                                                        </svg>
                                                    </div>
                                                </Nav.Link>
                                            </Nav.Item>
                                            {dropdown && (
                                                <>
                                                    {item?.menu_items.map(
                                                        (data, _index) => {
                                                            return (
                                                                <div
                                                                    key={
                                                                        _index
                                                                    }

                                                                    onClick={() =>
                                                                        handleLinkClick(
                                                                            data,
                                                                            _index
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="ps-5 ms-3">
                                                                        <p
                                                                            className={`mb-0 fs-14px my-2 cursor-pointer text-hover-primary delay-200 text-nowrap ${toggle
                                                                                ? 'opactiy-0'
                                                                                : 'opacity-100'
                                                                                }`}
                                                                        >
                                                                            {data?.routing_link ? (
                                                                                <Link
                                                                                    to={
                                                                                        data?.routing_link
                                                                                    }
                                                                                />
                                                                            ) : null}
                                                                            {
                                                                                data.name
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : <></>}
                                </>
                            )}
                        {permissionBasedSideBar.length > 0 &&
                            permissionBasedSideBar.map((item, index) =>
                                <Nav.Item
                                    as="li"
                                    className="mt-2 ps-4"
                                    key={item?.list_name}
                                    onClick={() =>
                                        handleLinkClick(item, index)
                                    }
                                >
                                    <Nav.Link
                                        href={item?.routing_link}
                                        target={item?.target}
                                        className="d-flex align-items-center justify-content-between position-relative h-40px p-0 nav-sidebar"
                                    >
                                        <div className="d-flex align-items-center">
                                            {item?.list_name.toLowerCase() === 'reports' ? (
                                                <>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="21.38"
                                                        height="21.38"
                                                        viewBox="0 0 21.38 21.38"
                                                        className="fill-color delay-200"
                                                    >
                                                        <path
                                                            id="analytics_FILL0_wght400_GRAD0_opsz24_1_"
                                                            data-name="analytics_FILL0_wght400_GRAD0_opsz24 (1)"
                                                            d="M124.751-823.371h2.376v-5.939h-2.376Zm9.5,0h2.376v-11.878h-2.376Zm-4.751,0h2.376v-3.563H129.5Zm0-5.939h2.376v-2.376H129.5Zm-7.127,10.69a2.288,2.288,0,0,1-1.678-.7A2.288,2.288,0,0,1,120-821v-16.629a2.287,2.287,0,0,1,.7-1.678,2.287,2.287,0,0,1,1.678-.7H139a2.287,2.287,0,0,1,1.678.7,2.287,2.287,0,0,1,.7,1.678V-821a2.288,2.288,0,0,1-.7,1.678,2.288,2.288,0,0,1-1.678.7Zm0-2.376H139v-16.629H122.376Zm0-16.629v0Z"
                                                            transform="translate(-120 840)"
                                                        />
                                                    </svg>
                                                    <p
                                                        className={`my-1 me-1 mt-2 fs-15px text-dark ms-3 delay-200 ${toggle
                                                            ? 'opacity-0'
                                                            : 'opacity-100'
                                                            }`}
                                                    >
                                                        {item?.list_name}
                                                    </p>
                                                </>
                                            ) : (item?.list_name.toLowerCase() === 'users' ?
                                                <>

                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="21.38"
                                                        height="21.38"
                                                        viewBox="0 0 20.003 14.547"
                                                        className="fill-color delay-200"
                                                    >
                                                        <path
                                                            id="group_FILL0_wght400_GRAD0_opsz24"
                                                            d="M40-785.453V-788a2.664,2.664,0,0,1,.4-1.421,2.652,2.652,0,0,1,1.057-.989,13.5,13.5,0,0,1,2.864-1.057,12.51,12.51,0,0,1,2.955-.352,12.51,12.51,0,0,1,2.955.352,13.5,13.5,0,0,1,2.864,1.057,2.652,2.652,0,0,1,1.057.989,2.664,2.664,0,0,1,.4,1.421v2.546Zm16.366,0v-2.728a3.658,3.658,0,0,0-.557-1.921,4.91,4.91,0,0,0-1.58-1.58,11.468,11.468,0,0,1,2.182.466,11.386,11.386,0,0,1,1.909.807,4.027,4.027,0,0,1,1.25,1.012A1.942,1.942,0,0,1,60-788.18v2.728Zm-9.092-7.274a3.5,3.5,0,0,1-2.569-1.068,3.5,3.5,0,0,1-1.068-2.568,3.5,3.5,0,0,1,1.068-2.569A3.5,3.5,0,0,1,47.274-800a3.5,3.5,0,0,1,2.569,1.068,3.5,3.5,0,0,1,1.068,2.569,3.5,3.5,0,0,1-1.068,2.568A3.5,3.5,0,0,1,47.274-792.726Zm9.092-3.637a3.5,3.5,0,0,1-1.068,2.568,3.5,3.5,0,0,1-2.569,1.068,4.545,4.545,0,0,1-.636-.057,5.591,5.591,0,0,1-.636-.125,5.408,5.408,0,0,0,.943-1.614,5.241,5.241,0,0,0,.33-1.841,5.242,5.242,0,0,0-.33-1.841,5.408,5.408,0,0,0-.943-1.614,2.766,2.766,0,0,1,.636-.148,5.961,5.961,0,0,1,.636-.034,3.5,3.5,0,0,1,2.569,1.068A3.5,3.5,0,0,1,56.366-796.363Zm-14.547,9.092h10.91V-788a.855.855,0,0,0-.125-.455.885.885,0,0,0-.33-.318,11.848,11.848,0,0,0-2.478-.921A10.549,10.549,0,0,0,47.274-790a10.549,10.549,0,0,0-2.523.307,11.848,11.848,0,0,0-2.478.921.885.885,0,0,0-.33.318.855.855,0,0,0-.125.455Zm5.455-7.274a1.751,1.751,0,0,0,1.284-.534,1.751,1.751,0,0,0,.534-1.284,1.751,1.751,0,0,0-.534-1.284,1.751,1.751,0,0,0-1.284-.534,1.751,1.751,0,0,0-1.284.534,1.751,1.751,0,0,0-.534,1.284,1.751,1.751,0,0,0,.534,1.284A1.751,1.751,0,0,0,47.274-794.545ZM47.274-787.271ZM47.274-796.363Z"
                                                            transform="translate(-40 800)"
                                                        />
                                                    </svg>
                                                    <p
                                                        className={`my-1 me-1 mt-2 fs-15px text-dark ms-3 delay-200 ${toggle
                                                            ? 'opacity-0'
                                                            : 'opacity-100'
                                                            }`}
                                                    >
                                                        {item?.list_name}
                                                    </p>
                                                </>
                                                : item?.list_name.toLowerCase() === "repository" ? (
                                                    <>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20.365"
                                                            height="18.91"
                                                            viewBox="0 0 20.365 18.91"
                                                        >
                                                            <g
                                                                id="Repo"
                                                                transform="translate(-11064.819 6912.999)"
                                                            >
                                                                <g
                                                                    id="Group_41264"
                                                                    data-name="Group 41264"
                                                                    transform="translate(34388.742 10965)"
                                                                >
                                                                    <g id="Group_41460" data-name="Group 41460">
                                                                        <g
                                                                            id="box"
                                                                            transform="translate(-23326.77 -17865.691)"
                                                                        >
                                                                            <path
                                                                                id="Path_54972"
                                                                                data-name="Path 54972"
                                                                                d="M21.5,25.71H15.685a1.455,1.455,0,0,1-1.455-1.455V22.8a1.455,1.455,0,0,1,1.455-1.455H21.5A1.455,1.455,0,0,1,22.959,22.8v1.455A1.455,1.455,0,0,1,21.5,25.71ZM15.685,22.8v1.455H21.5V22.8Z"
                                                                                transform="translate(-5.566 -25.653)"
                                                                            />
                                                                            <path
                                                                                id="Path_54973"
                                                                                data-name="Path 54973"
                                                                                d="M21.756,5.692H4.3A1.455,1.455,0,0,0,2.846,7.147v2.909A1.455,1.455,0,0,0,4.3,11.511V23.148A1.455,1.455,0,0,0,5.755,24.6H20.3a1.455,1.455,0,0,0,1.455-1.455V11.511a1.455,1.455,0,0,0,1.455-1.455V7.147A1.455,1.455,0,0,0,21.756,5.692ZM20.3,23.148H5.755V11.511H20.3Zm1.455-13.092H4.3V7.147H21.756Z"
                                                                                transform="translate(0 -18)"
                                                                            />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg> <p
                                                            className={`my-1 me-1 mt-2 fs-15px text-dark ms-3 delay-200 ${toggle
                                                                ? 'opacity-0'
                                                                : 'opacity-100'
                                                                }`}
                                                        >
                                                            {item?.list_name}
                                                        </p></>
                                                ) : <></>)}

                                        </div>
                                    </Nav.Link>

                                </Nav.Item>
                            )}
                    </Nav>

                    <div
                        className={`class="align-items-center bg-theme-grey-3 bg-white border border-0 cursor-pointer d-flex delay-200 h-30px justify-content-center position-absolute rounded-end-3 z-index-5" `}
                        style={{ bottom: '250px', right: '-14px' }}
                        onClick={displaySidebar}
                    >
                        <span  className={`d-flex align-items-center ${toggle ? '' : 'rotate-180deg'
                            }`}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 6 12"
                                fill="currentColor"
                                className="text-theme"
                            >
                                <path
                                    id="Path_53944"
                                    data-name="Path 53944"
                                    d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                                    transform="translate(5.85) rotate(90)"
                                ></path>
                            </svg>
                        </span>
                    </div>
                </div>
            )}
        </>
    );
};

export default SideBar;
